import React from 'react';

export const Option = (
  props: JSX.IntrinsicAttributes &
    React.ClassAttributes<HTMLOptionElement> &
    React.OptionHTMLAttributes<HTMLOptionElement>,
) => <option {...props} />;
